module.exports = __webpack_public_path__ + "static/img/xnyqc.f108e65f.png";